
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("JUEP5", function(module, exports) {
module.exports = JSON.parse("{\"dismissButton\":\"OK\",\"jira-issueview-status.issue-view-resolution-changeboarding-body\":\"To keep key information in one spot, we've moved the status and resolution field to the left\",\"jira-issueview-status.issue-view-resolution-changeboarding-heading\":\"Status is now on the left\",\"jira-issueview-status.issue-view-status-changeboarding-body\":\"To keep key information in one spot, we've moved status to the left\",\"jira-issueview-status.issue-view-status-changeboarding-heading\":\"Status is now on the left\",\"post-office.jira-issueview-status.main-heading.no-translate\":\"Welcome to Jira Issue View Status\"}");

});


//# sourceMappingURL=en-GB.b69b48c1.js.map
